export default __webpack_public_path__ + "static/media/Res2.12627c6f.jpeg";